export enum EJDNavigationBarCanPull {
  Disable = '0',
  Enable = '1',
  Custom = '2'
}

export enum EJDNavigationBarSupportTran {
  Unsupport = '0',
  Support = '1'
}

export enum EJDNavigationBarMenuType {
  WhiteAndWhite = 'ww',
  WhiteAndBlack = 'wb',
  BlackAndBlack = 'bb',
  BlackAndWhite = 'bw'
}

export enum EPageBouncesStatus {
  Disable = 0,
  Enable
}

export type TJDNavigationBarCallbackSuccessCode = '0' | '0000'

export interface IConfigNavigationBarParams {
  canPull: EJDNavigationBarCanPull
  supportTran:EJDNavigationBarSupportTran
  tranParams: {
    naviMenuType: EJDNavigationBarMenuType
  }
}

export interface IConfigNavigationBarResponse {
  status: string
  data?: {
    isImmersive: boolean // 是否是沉浸式（Android场景会返回）
    naviBarHeight: number // 状态栏+导航栏高度（Android场景会返回）
    navigationHeight: number // 导航栏高度（Android场景会返回）
    statusBarHeight: number // 状态栏高度（Android场景会返回）
  }
}

export type TGetAppversionParams = 'jd' | 'qq' | 'wx'

export interface IJDBridge {
  /**
   * @description 注册webview
   * @param code 注册码
   */
  registerCode: (code: string) => void
  /**
   * @description 关闭当前webview
   */
  closeWebview: () => void
  /**
   * @description 设置导航栏样式
   */
  configNavigationBar: (params: IConfigNavigationBarParams) => Promise<IConfigNavigationBarResponse>
  /**
   * @description 返回上一页，若当前是第一页则关闭当前webview
   */
  goBackRouter: () => void
  /**
   * @description 控制iOS的webview在页面滚动到顶部或底部时的回弹动画效果（仅iOS有效）
   * @param status 是否启用回弹效果
   */
  togglePageBounces: (status: EPageBouncesStatus) => void
  /**
   * @description 获取App版本号
   */
  getAppVersion: (appName: TGetAppversionParams, ua?: string) => string
  /**
   * @description 跳转至系统设置页面
   */
  settingsRouter:()=>Promise<void>
}
